import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _classPrivateFieldSet from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _toConsumableArray from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

var _Symbol$iterator;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

import { TrackEvent } from "./track-event.js";
import { getPrivate } from "./utils.js";

function addAudioTrack(media, track) {
  var trackList = media.audioTracks;
  getPrivate(track).media = media;

  if (!getPrivate(track).renditionSet) {
    getPrivate(track).renditionSet = /* @__PURE__ */new Set();
  }

  var trackSet = getPrivate(trackList).trackSet;
  trackSet.add(track);
  var index = trackSet.size - 1;

  if (!(index in AudioTrackList.prototype)) {
    Object.defineProperty(AudioTrackList.prototype, index, {
      get: function get() {
        return _toConsumableArray(getPrivate(this).trackSet)[index];
      }
    });
  }

  queueMicrotask(function () {
    trackList.dispatchEvent(new TrackEvent("addtrack", {
      track: track
    }));
  });
}

function removeAudioTrack(track) {
  var _getPrivate$media;

  var trackList = (_getPrivate$media = getPrivate(track).media) === null || _getPrivate$media === void 0 ? void 0 : _getPrivate$media.audioTracks;
  if (!trackList) return;
  var trackSet = getPrivate(trackList).trackSet;
  trackSet.delete(track);
  queueMicrotask(function () {
    trackList.dispatchEvent(new TrackEvent("removetrack", {
      track: track
    }));
  });
}

function enabledChanged(track) {
  var trackList = getPrivate(track).media.audioTracks;
  if (!trackList || getPrivate(trackList).changeRequested) return;
  getPrivate(trackList).changeRequested = true;
  queueMicrotask(function () {
    delete getPrivate(trackList).changeRequested;
    trackList.dispatchEvent(new Event("change"));
  });
}

var _addTrackCallback = /*#__PURE__*/new WeakMap();

var _removeTrackCallback = /*#__PURE__*/new WeakMap();

var _changeCallback = /*#__PURE__*/new WeakMap();

var _tracks = /*#__PURE__*/new WeakMap();

_Symbol$iterator = Symbol.iterator;

var AudioTrackList = /*#__PURE__*/function (_EventTarget) {
  _inherits(AudioTrackList, _EventTarget);

  var _super = _createSuper(AudioTrackList);

  function AudioTrackList() {
    var _this;

    _classCallCheck(this, AudioTrackList);

    _this = _super.call(this);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _tracks, {
      get: _get_tracks,
      set: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _addTrackCallback, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _removeTrackCallback, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _changeCallback, {
      writable: true,
      value: void 0
    });

    getPrivate(_assertThisInitialized(_this)).trackSet = /* @__PURE__ */new Set();
    return _this;
  }

  _createClass(AudioTrackList, [{
    key: _Symbol$iterator,
    value: function value() {
      return _classPrivateFieldGet(this, _tracks).values();
    }
  }, {
    key: "length",
    get: function get() {
      return _classPrivateFieldGet(this, _tracks).size;
    }
  }, {
    key: "getTrackById",
    value: function getTrackById(id) {
      var _find;

      return (_find = _toConsumableArray(_classPrivateFieldGet(this, _tracks)).find(function (track) {
        return track.id === id;
      })) !== null && _find !== void 0 ? _find : null;
    }
  }, {
    key: "onaddtrack",
    get: function get() {
      return _classPrivateFieldGet(this, _addTrackCallback);
    }
  }, {
    key: "onaddtrack",
    set: function set(callback) {
      if (_classPrivateFieldGet(this, _addTrackCallback)) {
        this.removeEventListener("addtrack", _classPrivateFieldGet(this, _addTrackCallback));

        _classPrivateFieldSet(this, _addTrackCallback, void 0);
      }

      if (typeof callback == "function") {
        _classPrivateFieldSet(this, _addTrackCallback, callback);

        this.addEventListener("addtrack", callback);
      }
    }
  }, {
    key: "onremovetrack",
    get: function get() {
      return _classPrivateFieldGet(this, _removeTrackCallback);
    }
  }, {
    key: "onremovetrack",
    set: function set(callback) {
      if (_classPrivateFieldGet(this, _removeTrackCallback)) {
        this.removeEventListener("removetrack", _classPrivateFieldGet(this, _removeTrackCallback));

        _classPrivateFieldSet(this, _removeTrackCallback, void 0);
      }

      if (typeof callback == "function") {
        _classPrivateFieldSet(this, _removeTrackCallback, callback);

        this.addEventListener("removetrack", callback);
      }
    }
  }, {
    key: "onchange",
    get: function get() {
      return _classPrivateFieldGet(this, _changeCallback);
    }
  }, {
    key: "onchange",
    set: function set(callback) {
      if (_classPrivateFieldGet(this, _changeCallback)) {
        this.removeEventListener("change", _classPrivateFieldGet(this, _changeCallback));

        _classPrivateFieldSet(this, _changeCallback, void 0);
      }

      if (typeof callback == "function") {
        _classPrivateFieldSet(this, _changeCallback, callback);

        this.addEventListener("change", callback);
      }
    }
  }]);

  return AudioTrackList;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));

function _get_tracks() {
  return getPrivate(this).trackSet;
}

export { AudioTrackList, addAudioTrack, enabledChanged, removeAudioTrack };